import React from "react";
import { Col, Container, Row } from "react-bootstrap";
import {
  FlutterDubaiConsIcon,
  FlutterDubaiDesignIcon,
  FlutterDubaiAppIcon,
  FlutterDubaiMigIcon,
  FlutterDubaiSuppIcon,
  IOSDubaiMainIcon,
} from "../../../app-constants";
import { Link } from "gatsby";

const StackItem = [
  {
    icon: FlutterDubaiConsIcon,
    title: "Flutter App Consultation",
    description:
      "Our expert consultants work closely with the clients to understand the unique requirements of the project based on their objectives. We provide our professional guidance throughout the whole consultation process to ensure clarity of the project’s scope. Further, you can have our valuable recommendations to ensure your Flutter app aligns with your business goals.",
  },
  {
    icon: FlutterDubaiDesignIcon,
    title: "Flutter App Design",
    description:
      "We have a talented team of designers who combine creativity with functionality to create exceptional UI/UX designs. Keeping in mind the brand image of your businesses, we customize the Flutter elements to provide the best user experience. Moreover, our professional designers craft visually appealing interfaces that engage the users throughout their journey.",
  },
  {
    icon: FlutterDubaiAppIcon,
    title: "Flutter App Development",
    description:
      "Our experienced developers understand the innovative capabilities of Flutter and they build high-level mobile applications accordingly. You can have feature-rich functionality with a smooth performance in your app solution based on efficient customization. We ensure your Flutter app provides an ideal user experience across different devices with optimal functionality.",
  },
  {
    icon: FlutterDubaiMigIcon,
    title: "Flutter App Migration",
    description:
      "We enable our clients to upgrade their existing mobile app to Flutter with our proven migration services. Our professionals manage the entire migration process efficiently without any compromise on your app's functionality and user experience. That’s how you can take advantage of the latest features of Flutter to enhance your app's performance.",
  },
  {
    icon: FlutterDubaiSuppIcon,
    title: "Flutter App Support & Maintenance",
    description:
      "You can have our dedicated support and maintenance services to ensure that your Flutter app remains updated to provide optimal performance. We facilitate regular updates and bug fixes to enhance the app’s functionality. Further, you can rely on our maintenance services to scale up your app based on the increasing business requirements in the future.",
  },
  {
    icon: IOSDubaiMainIcon,
    title: "Flutter App Testing",
    description:
      "Our comprehensive testing services ensure the reliability and quality of your Flutter app across various scenarios. We conduct thorough testing to identify and rectify any potential issues, ensuring seamless functionality across different devices and operating systems. Our testing process includes functional testing, performance testing, compatibility testing, and user acceptance testing to guarantee a flawless user experience.",
  },
];

function Improvise(props) {
  return (
    <div className="improvise_section p-100">
      <Container className="h-100">
        <Row className="h-100">
          <Col
            xs={12}
            md={12}
            lg={12}
            xl={10}
            xxl={4}
            className="m-xl-auto m-xxl-0"
          >
            <h2>
              Experience the Best Flutter App Development Services in Dubai
            </h2>
            <p className="impro_para">
              We help you leverage the innovative features with our efficient
              Flutter app development services in Dubai. That’s how we build
              customized{" "}
              <Link to="https://www.tekrevol.com/mobile-app-development-company-dubai">
                mobile app solutions
              </Link>{" "}
              as per your unique business needs, ensuring a smooth performance
              across different platforms. Following are the services that we
              offer by using the power of Flutter technology:
            </p>
          </Col>
          <Col xs={12} md={12} lg={12} xl={12} xxl={8}>
            <div className="stack_box">
              {StackItem.map((item, index) => (
                <div className="stack_item" key={index}>
                  <div className="stack_title">
                    {item.icon}
                    <h5>{item.title}</h5>
                  </div>
                  <p>{item.description}</p>
                </div>
              ))}
            </div>
          </Col>
        </Row>
      </Container>
    </div>
  );
}

export default Improvise;
